import { render, staticRenderFns } from "./NewsComment.vue?vue&type=template&id=ffeceed0&scoped=true&"
import script from "./NewsComment.vue?vue&type=script&lang=js&"
export * from "./NewsComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffeceed0",
  null
  
)

export default component.exports